import { render } from "./PropertyCard.vue?vue&type=template&id=f6c3a012&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"

import "./PropertyCard.vue?vue&type=style&index=0&id=f6c3a012&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c3a012"]])

export default __exports__